<template>
  <v-btn v-if="isAdmin" color="red" icon @click="$emit('click')">
    <v-icon>mdi-delete</v-icon>
  </v-btn>
</template>

<script>
export default {};
</script>

<style></style>
